/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState} from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DBRadioButtonNew from 'framework/components/DBRadioButtonNew'

const PromotionGroupMasterContent = ({
    CodeValue,
    CodeonChange,
    DescValue,
    DescOnChange,
    disabled,
    SwonChange,
    ActiveSw,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    disabledCode,
    CodeOnBlur,
    ErrorMsg,
    menuName,
    onButtonClick,
    btnDisable,
    SearchDisable,
    OUTLET,
    SetOutlet,
    PAYACT,
    SetPayAct,
    EXCLACT,
    SetExclAct,
    PSKBUID,
    SetPSKBUID,
    GRPBID,
    SetGRPBID,
    DISKPER,
    SetDISKPER,
    DISKAMT,
    SetDISKAMT,
    FSKUBID,
    SetFSKUBID,
    TICKET,
    SetTICKET,
    VOUACT,
    SetVOUACT,
    POINTS,
    SetPOINTS,
    SetInclAct,
    INCLACT,
    CUSTOMERSPECIFIC,
    SetCUSTOMERSPECIFIC,
    autoCode,
    menuCode,
    SetExcludeGroup1,
    SetExcludeGroup2,
    ExcludeGroup1,
    ExcludeGroup2,
    IncludeGroup1,
    IncludeGroup2,
    SetIncludeGroup1,
    SetIncludeGroup2,
    CARD,
    SetCARD,
    SetCouponRedemption,
    CouponRedemption,
    SetExcludeInclusiveItem,
    ExcludeInclusiveItem,
    SetValidQtyCheckSKU,
    ValidQtyCheckSKU,
    DiscAmtApplyToBill,
    SetDiscAmtApplyToBill,
    SetTICKETVALUE,
    TICKETVALUE,
    SetPricemode,
    pricemode,
    SetComboType,
    comboType,
    valueCheckForOfferItems,
    valueCheckForBill,
    setValueCheckForOfferItems,
    setValueCheckForBill,
    setintStockCodeWise,
    intStockCodeWise
}) => {
    //*** useState to save table data */
    const [Datatablesub, SetDatatablesub] = useState([])
    const [groupFilter, SetGroupFilter] = useState('a')
    //*** End of useStates */
    const ApiURL = window.Links.ApiURL

    function tog_backdrop() {
        modelTrigger();
    }

    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];


    const columns2 = [{
        field: "PG_CODE",
        title: "Code",
        align: "center",
    },
    {
        field: "PG_DESC",
        title: "Description",
        align: "center",
    },];

    const radio1 = [{ label: "Qty", value: 1, name: "IncludesChecked" }, { label: " Value", value: 2, name: "IncludesChecked" }]
    const radio2 = [{ label: "Qty", value: 1, name: "ExcluedesChecked" }, { label: " Value", value: 2, name: "ExcluedesChecked" }]
    const radio3 = [{ label: "Item", value: 1, name: "IncludesBasedOn" }, { label: "Combination", value: 2, name: "IncludesBasedOn" }]
    const radio4 = [{ label: "Item", value: 1, name: "ExcluedesBasedOn" }, { label: "Combination", value: 2, name: "ExcluedesBasedOn" }]

    function setExcludeRadioData1(e) {
        SetExcludeGroup1(e.target.value)
    }

    function setExcludeRadioData2(e) {
        SetExcludeGroup2(e.target.value)
    }

    function setIncludeRadioData1(e) {
        SetIncludeGroup1(e.target.value)
    }

    function setIncludeRadioData2(e) {
        SetIncludeGroup2(e.target.value)
    }


    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={12} className="mb-4-sm">
                                <Row>
                                    <Col sm={12} md={6} className="mb-4-sm">
                                        <DPTextBoxButton
                                            rowClass="mb-4-sm"
                                            labelText="Code *"
                                            textType="text"
                                            maxLength="5"
                                            value={CodeValue}
                                            onChange={CodeonChange}
                                            onBlur={CodeOnBlur}
                                            disabled={disabled == true ? disabled : disabledCode}
                                            onButtonClick={onButtonClick}
                                            btnDisable={disabled == true ? disabled : btnDisable}
                                            placeholder={autoCode}

                                        />
                                    </Col>
                                    <Col>
                                        <Button
                                            onClick={() => {
                                                tog_backdrop()
                                            }}
                                            color="success"
                                            className="btn-sm"
                                            disabled={SearchDisable}
                                        >
                                            <i
                                                className="mdi mdi-search-web"
                                                style={{ fontSize: "12px" }}
                                            ></i>
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={6} className="mb-4-sm">
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Description *"
                                            textType="text"
                                            maxLength="50"
                                            value={DescValue}
                                            onChange={DescOnChange}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>


                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Outlet
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetOutlet}
                                            checked={OUTLET}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Payment Modes
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetPayAct}
                                            checked={PAYACT}
                                            disabled={disabled}
                                        />
                                    </Col>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Bins
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetCARD}
                                            checked={CARD}
                                            disabled={disabled ? true : PAYACT ? false : true}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Product Bundles
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetPSKBUID}
                                            checked={PSKBUID}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Group Bundles
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetGRPBID}
                                            checked={GRPBID}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Discount Percentage
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetDISKPER}
                                            checked={DISKPER}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Discount Amount
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetDISKAMT}
                                            checked={DISKAMT}
                                            disabled={disabled}
                                        />
                                    </Col>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Apply to total Bill
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetDiscAmtApplyToBill}
                                            checked={DiscAmtApplyToBill}
                                            disabled={disabled ? true : DISKAMT ? false : true}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Free Item Bundle
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetFSKUBID}
                                            checked={FSKUBID}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Tickets
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetTICKET}
                                            checked={TICKET}
                                            disabled={disabled}
                                        />
                                    </Col>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Value
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetTICKETVALUE}
                                            checked={TICKETVALUE}
                                            disabled={disabled ? true : TICKET ? false : true}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Voucher
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetVOUACT}
                                            checked={VOUACT}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Points
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetPOINTS}
                                            checked={POINTS}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Customer Specific
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetCUSTOMERSPECIFIC}
                                            checked={CUSTOMERSPECIFIC}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Status
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SwonChange}
                                            checked={ActiveSw}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Includes
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetInclAct}
                                            checked={INCLACT}
                                            disabled={disabled}
                                        />
                                    </Col>
                                    {/* {INCLACT ? <Col sm={12} md={1} className="mb-4-sm">Checked</Col> : null} */}
                                    {INCLACT ? <Col sm={12} md={4} className="mb-3-sm">
                                        <DBRadioButtonNew
                                            labelShow={true}
                                            labelText={"Checked"}
                                            rowClass="mb-4-sm"
                                            types={radio1}
                                            OnChange={setIncludeRadioData1}
                                            value={IncludeGroup1}
                                            Disabled={disabled}
                                        />
                                    </Col> : null}
                                    {/* {INCLACT ? <Col sm={12} md={1} className="mb-4-sm">Based On</Col> : null} */}
                                    {INCLACT ? <Col sm={12} md={4} className="mb-4-sm">
                                        <DBRadioButtonNew
                                            labelShow={true}
                                            labelText={"Based On"}
                                            rowClass="mb-4-sm"
                                            types={radio3}
                                            OnChange={setIncludeRadioData2}
                                            value={IncludeGroup2}
                                            Disabled={disabled}
                                        />
                                    </Col> : null}
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Exclusion
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetExclAct}
                                            checked={EXCLACT}
                                            disabled={disabled}
                                        />
                                    </Col>
                                    {EXCLACT ? <Col sm={12} md={4} className="mb-4-sm">
                                        <DBRadioButtonNew
                                            labelShow={true}
                                            labelText={"Checked"}
                                            rowClass="mb-4-sm"
                                            types={radio2}
                                            OnChange={setExcludeRadioData1}
                                            value={ExcludeGroup1}
                                            Disabled={disabled}
                                        />
                                    </Col> : null}
                                    {EXCLACT ? <Col sm={12} md={4} className="mb-4-sm">
                                        <DBRadioButtonNew
                                            labelShow={true}
                                            labelText={"Based On"}
                                            rowClass="mb-4-sm"
                                            types={radio4}
                                            OnChange={setExcludeRadioData2}
                                            value={ExcludeGroup2}
                                            Disabled={disabled}
                                        />
                                    </Col> : null}
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Coupon Redemption
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetCouponRedemption}
                                            checked={CouponRedemption}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Exclude the inclusive items
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetExcludeInclusiveItem}
                                            checked={ExcludeInclusiveItem}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Valid qty check for SKU
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetValidQtyCheckSKU}
                                            checked={ValidQtyCheckSKU}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Price Mode
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetPricemode}
                                            checked={pricemode}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Combination Promo
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SetComboType}
                                            checked={comboType}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Value Check for bill
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={setValueCheckForBill}
                                            checked={valueCheckForBill}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Value Check for offer items
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={setValueCheckForOfferItems}
                                            checked={valueCheckForOfferItems}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            StockCode Wise Promo
                                        </Label>
                                    </Col>
                                    <Col sm={12} md={1} className="mb-4-sm">
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={setintStockCodeWise}
                                            checked={intStockCodeWise}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>
                            </Col>

                            <DPSearchBoxDynamic
                                searchData={Datatablesub}
                                columns={columns2}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"PROMOGRP"}
                                MenuCode={menuCode}
                                KeyVal={'GRP'}
                                searchBy={'PG_CODE'}
                                FilterStr={groupFilter}
                            />

                        </Row>
                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    )

}

export default PromotionGroupMasterContent